module.exports = __webpack_public_path__ + "img/LK.0cbb8160.svg";